import { FooterMain, HeaderMain } from "./layout"
import { Heading } from "./layout/Heading"

export const Support = () => {
  return (
    <>
      <HeaderMain />
      <div className="text-center heading-section">
        <h4 className="main-heading">
          <span>Responsible Gambling</span> Support Page
        </h4>
      </div>
      <div className="container mb-5">
        <p>
          Based on your answers, we’re not able to recommend any casino or
          sportsbook offers right now.
        </p>
        <p>
          That doesn’t mean anything is wrong — it just means that at PlayCan,
          we take responsible gambling seriously, and want to make sure every
          experience stays safe, positive, and in your control.
        </p>
        <p>
          Then, Feature{" "}
          <b> ConnexOntario’s toll-free number: 1-866-531-2600 </b> Links to
          <a
            href="https://playcan.ca/responsible-
gambilng?ba=playcan"
          >
            &nbsp;Responsible Gambling Info Hub
          </a>
        </p>
      </div>
      <FooterMain />
    </>
  )
}
